import { defineStore } from 'pinia'
import { queryPermissionList } from '@/api/admin'
import type { Permission } from '@/types/global'
// import { SCREEN_ROUTE } from '@/const/const'

export const commonStore = defineStore('common', () => {
  const isShowMenu = ref(true)
  const permissionList = ref<Permission[] | null>(null) // 未查询权限列表前为null，查询后为[]
  const activeResourceUrl = ref('')
  const activeRouterIdList = ref<string[]>([])

  const routerList = computed(() => {
    return (permissionList.value || []).reduce((sum: Permission[], item: Permission) => {
      if (item.resourceUrl)
        sum.push(item)
      return sum.concat((item.children || []).filter(child => child.resourceUrl))
    }, [])
  })

  // const activeRouterList = computed(() => {
  //   return routerList.value.filter(routerItem => activeRouterIdList.value.includes(routerItem.id)) // TODO 确认是resourceId还是id
  // })

  const firstRouter = computed(() => {
    const temp = (routerList.value || [])[1]
    // const temp = (routerList.value || []).find(item => item.parentResourceId !== '9' && !SCREEN_ROUTE.includes(item.resourceUrl))
    return (temp || {}).resourceUrl || '/personal-center' // 没有权限时去个人中心
  })

  const resourceIdList = computed(() => {
    return getChildrenPermission(permissionList.value || [])
  })

  function getChildrenPermission(permission: Permission[]) {
    let flatPermission: Permission[] = []
    permission.forEach((item) => {
      if (item.children && item.children.length)
        flatPermission = flatPermission.concat(getChildrenPermission(item.children))
      else
        flatPermission.push(item)
    })
    return flatPermission
  }
  async function queryPermission() {
    return queryPermissionList().then((res: Permission[]) => {
      if (!(res && res.length))
        permissionList.value = []
      else
        permissionList.value = res[0].children || []
    }).catch((error) => {
      return Promise.reject(error)
    })
  }
  return {
    permissionList,
    activeRouterIdList,
    queryPermission,
    routerList,
    // activeRouterList,
    firstRouter,
    isShowMenu,
    activeResourceUrl,
    resourceIdList,
  }
})
